import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import api from '../api';
import {
  ThirdPartyToLocalIdRequest,
  ThirdPartyToLocalIdResponse,
} from '@dreamai/types';
import EmailComponent from './chat/canvas/dsl-components/EmailComponent';

interface EmailConfirmWrapperProps {
  methodInput: {
    draftId: string;
    oauthId?: string;
    provider?: string;
  };
}

const EmailConfirmWrapper: React.FC<EmailConfirmWrapperProps> = ({
  methodInput,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const [localEmailId, setLocalEmailId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const convertToLocalId = async () => {
      try {
        const accessToken = await getAccessTokenSilently();

        const requestData: ThirdPartyToLocalIdRequest = {
          provider: methodInput.provider || '',
          id: methodInput.draftId,
          oauthId: methodInput.oauthId,
        };

        const response = await api.put<ThirdPartyToLocalIdResponse>(
          '/agent-email-storage/third-party-to-local-id',
          requestData,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          },
        );

        if (response.data.success && response.data.localEmailId) {
          setLocalEmailId(response.data.localEmailId);
        } else {
          setError(response.data.error || 'Failed to convert email ID');
        }
      } catch (err: any) {
        setError(err.response?.data?.error || 'Failed to load email data');
      } finally {
        setLoading(false);
      }
    };

    convertToLocalId();
  }, [
    methodInput.draftId,
    methodInput.oauthId,
    methodInput.provider,
    getAccessTokenSilently,
  ]);

  if (loading) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <div className='loading-spinner'></div>
        <p>Loading email...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: '20px', textAlign: 'center', color: '#d32f2f' }}>
        <p>Error: {error}</p>
      </div>
    );
  }

  if (!localEmailId) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <p>Email not found</p>
      </div>
    );
  }

  return <EmailComponent emailId={localEmailId} removeDedicatedSubmitButton />;
};

export default EmailConfirmWrapper;
